var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypeManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 9.62H12.87C12.46 9.62 12.12 9.28 12.12 8.87C12.12 8.46 12.46 8.12 12.87 8.12H18.12C18.53 8.12 18.87 8.46 18.87 8.87C18.87 9.28 18.54 9.62 18.12 9.62Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62 10.38C7.43 10.38 7.24 10.31 7.09 10.16L6.34 9.41C6.05 9.12 6.05 8.64 6.34 8.35C6.63 8.06 7.11 8.06 7.4 8.35L7.62 8.57L9.34 6.85C9.63 6.56 10.11 6.56 10.4 6.85C10.69 7.14 10.69 7.62 10.4 7.91L8.15 10.16C8.01 10.3 7.82 10.38 7.62 10.38Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 16.62H12.87C12.46 16.62 12.12 16.28 12.12 15.87C12.12 15.46 12.46 15.12 12.87 15.12H18.12C18.53 15.12 18.87 15.46 18.87 15.87C18.87 16.28 18.54 16.62 18.12 16.62Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62 17.38C7.43 17.38 7.24 17.31 7.09 17.16L6.34 16.41C6.05 16.12 6.05 15.64 6.34 15.35C6.63 15.06 7.11 15.06 7.4 15.35L7.62 15.57L9.34 13.85C9.63 13.56 10.11 13.56 10.4 13.85C10.69 14.14 10.69 14.62 10.4 14.91L8.15 17.16C8.01 17.3 7.82 17.38 7.62 17.38Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H15.5C20.93 1.25 23.25 3.57 23.25 9V15C23.25 20.43 20.93 22.75 15.5 22.75ZM9.5 2.75C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V9C21.75 4.39 20.11 2.75 15.5 2.75H9.5Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeManagement);
export default __webpack_public_path__ + "static/media/TypeManagement.99d3e47e.svg";
export { ForwardRef as ReactComponent };